import { makeStyles } from '@material-ui/core/styles';

export const useMLFlowStyles = makeStyles(theme => ({
  avatar: {
    height: 32,
    width: 32,
    borderRadius: '50%',
  },
  mlFlowContainer: {
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    backgroundColor: '#FFFFFF',
    backgroundImage: 'unset',
    borderRadius: 4,
    overflow: 'hidden',
  },
  logSection: {
    fontFamily: 'monospace', 
    fontSize: '12px',
    whiteSpace: 'pre-wrap',
    backgroundColor: '#f5f5f5',
    padding: '8px',
    borderRadius: '4px',
    maxHeight: '300px',
    overflowY: 'auto',
  },
  successCard: {
    backgroundColor: '#d4edda',
    borderColor: '#c3e6cb',
    color: '#155724',
    padding: theme.spacing(1.5, 2),
  },
  errorCard: {
    backgroundColor: '#f8d7da',
    borderColor: '#f5c6cb',
    color: '#721c24',
    padding: theme.spacing(1.5, 2),
  },
  infoCard: {
    backgroundColor: '#d1ecf1',
    borderColor: '#bee5eb',
    color: '#0c5460',
    padding: theme.spacing(1.5, 2),
  },
  versionCard: {
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 150,
  },
  versionCardContent: {
    padding: theme.spacing(1.25),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,
  },
}));

export const modelOverviewStyles = {
  label: {
    textTransform: 'uppercase' as const,
    fontSize: 10,
    fontWeight: 'bolder',
    letterSpacing: 1,
    color: '#7a7a7a',
    marginBottom: 6,
  },
  valuePrimary: {
    color: '#d46a27',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
  },
  smallValue: {
    fontSize: 12,
  },
};
